import React, { useState, useMemo, useEffect, useCallback, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../quotation/QuotationGeneral.scss";
import "react-datepicker/dist/react-datepicker.css";
import {
  CheckNull,
  CurrencyConvertion,
  formatDate,
  FormatValueDecimal,
} from "../../utils/Validate";
import DeleteModal from "../../components/common/DeleteModal";
import SaveSuccessModel from "../../components/common/SaveSuccessModel";
import DataSearch from "../../utils/DataSearch";
import FetchData, {
  DeleteEntry,
  UpdateQuotationStatus,
  GetOne,
  CreateEntry,
  GetList,
  PaginationFetchData,
} from "../../providers/dataProvider";
import UpdateStatus from "../../components/quotation/UpdateStatus";
import calculateQuoteStatistics from "../../hooks/calculateQuoteStatistics";
import ErrorMessage from "../../components/common/ErrorMessage";
import QuotationGeneralViewGrid from "../../components/quotation/QuotationGeneralViewGrid";
import QuotationFilterDropdown from "../../components/quotation/QuotationFilterDropdown";
import filterrSvg from "../.././assets/images/funnel.svg";
import ConfirmModal from "../../components/common/ConfirmModal";
import jobInHand from "../.././assets/images/jobInHand.png";
import tender from "../.././assets/images/tender.png";
import { useRolePermission } from "../../hooks/useRolePermission";
import PaginationComponent from "../../components/common/PaginationComponent";

const QUOTATION_GENERAL_FILTER_FIELDS = [
  {
    value: "customer",
    label: "Customer",
    dpDownName: "customer",
    placeholder: "Choose a customer",
  },
  {
    value: "salesEngineer",
    label: "Sales Engineer",
    dpDownName: "salesengineer",
    placeholder: "Choose a sales engineer",
  },
  {
    value: "quoteDate",
    label: "Quote Date",
  },
];

const createFilterRow = (field = "customer") => ({
  id: `${field}-${Date.now()}-${Math.random().toString(16).slice(2)}`,
  field,
  value: null,
  fromDate: "",
  toDate: "",
});

const toDateOnly = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toISOString().slice(0, 10);
};

const QuotationGeneral = () => {
  const location = useLocation();
  const [projectName, setProjectName] = useState("");
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [displayData, setDisplayData] = useState([]);
  const [quotationData, setQuotationData] = useState([]);
  const [customer, setCustomer] = useState([]);
  const [clrFilter, setClrFilter] = useState(false);
  const [search, setSearch] = useState("");
  const [pageSize, setPageSize] = useState(25);
  const [pageNumber, setPageNumber] = useState(1);
  const [deleteShow, setDeleteShow] = useState({
    show: false,
    item: "",
    title: "",
    textCode: "",
    text: "",
    loading: false,
  });
  const [createMsg, setCreateMsg] = useState(null);
  const [successShow, setSuccessShow] = useState(false);
  const [filterRows, setFilterRows] = useState([createFilterRow()]);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const commandBarRef = useRef(null);
  const [hasActiveFilters, setHasActiveFilters] = useState(false);
  const [openStatus, setOpenStatus] = useState({ open: false, item: "" });
  const [refreshSearch, setRefreshSearch] = useState(false);
  const [quoteStatistics, setQuoteStatistics] = useState({});
  const [projectCode, setprojectCode] = useState(null);
  const [quotation, setQuotation] = useState({});
  const [loading, setLoading] = useState(true);
  const [copyQuoteConfirm, setCopyQuoteConfirm] = useState(false);
  const [errorShow, setErrorShow] = useState({ show: false, errorMessage: "" });

  const { menuRights } = useRolePermission("Quotation");
  const { data: salesEngineerData } = FetchData("userprofile");
  const { data: customerData } = FetchData("Customer");
  const { data: quotationStatus } = FetchData("quotationStatus");
  const { data: currencyList } = FetchData("currency");
  const userId = localStorage.getItem("authidentity")
  const [filterDataList, setFilterDataList] = useState({
    ProjectId: "",
    UserId: "",
    SearchTerm: ""
  });
  const [searchHistory, setSearchHistory] = useState([]);
  const [showSearchHistory, setShowSearchHistory] = useState(false);
  const [filteredHistory, setFilteredHistory] = useState([]);
  useEffect(() => {
    if (location?.state?.id) {
      setFilterDataList({
        ProjectId: location.state.id,
        UserId: userId,
        SearchTerm: ""
      });
    }
  }, [location?.state]);

  const { data: quotations, loadings } = PaginationFetchData(
    "quotation",
    filterDataList
  );
  useEffect(() => {
    if (location?.state) {
      setLoading(true);
      const item = location?.state;
      GetOne("quotationproject", { id: location?.state.id }, (res) => {
        setQuotation(res);
        setLoading(false);
      });
      setProjectName(item?.row?.projectName);
      setprojectCode(item?.row?.projectReference);
    }
  }, [location?.state]);

  useEffect(() => {
    window.dispatchEvent(new CustomEvent("pathfinderHeaderMetaChange", {
      detail: {
        pathname: "/quotation-general",
        title: projectName || "Quote Register",
        backTarget: { pathname: "/quotation" },
      },
    }));

    return () => {
      window.dispatchEvent(new CustomEvent("pathfinderHeaderMetaChange", {
        detail: {
          pathname: "/quotation-general",
          clear: true,
        },
      }));
    };
  }, [projectName]);

  useEffect(() => {
    const raw = quotation?.data?.payload ?? quotation?.data ?? [];
    const safeData = Array.isArray(raw) ? raw : [];
    setData(safeData);
    setQuoteStatistics(calculateQuoteStatistics(safeData, currencyList));
    setPageNumber(1);
  }, [quotation]);

  useEffect(() => {
    if (!Array.isArray(data)) return;
    let filterdata = data.map((filterItem) => {
      const nextItem = { ...filterItem };
      let customerName = "";
      var customerValue = customerData.filter((item) => item.id === filterItem.customerId);
      if (customerValue) customerName = customerValue[0]?.customerName;
      nextItem.customerName = customerName;

      let salesEngName = "";
      var salesValue = salesEngineerData.filter((item) => item.identityId === filterItem.salesEngineerId);
      if (salesValue)
        salesEngName = salesValue[0]?.firstName + " " + salesValue[0]?.lastName;
      nextItem.salesEngineerName = salesEngName;

      nextItem.quotesTypeName = filterItem?.quoteType == "1" ? "Job In Hand" : "Tender";

      let quoteStatusName = "";
      var quoteStatusValue = quotationStatus.filter((item) => item.id === filterItem.quoteStatusId);
      if (quoteStatusValue) quoteStatusName = quoteStatusValue[0]?.statusDesc;
      nextItem.quoteStatus = quoteStatusName;
      return nextItem;
    });
    setDisplayData(filterdata);
    setQuotationData(filterdata);
  }, [data, customerData, salesEngineerData, quotationStatus]);

  useEffect(() => {
    setPageNumber(1);
  }, [pageSize]);

  useEffect(() => {
    const totalPages = Math.max(1, Math.ceil((quotationData?.length ?? 0) / pageSize));
    if (pageNumber > totalPages) {
      setPageNumber(totalPages);
    }
  }, [quotationData, pageSize]);

  const currentTableData = useMemo(() => {
    const firstPageIndex = (pageNumber - 1) * pageSize;
    const lastPageIndex = firstPageIndex + pageSize;
    return quotationData?.slice(firstPageIndex, lastPageIndex);
  }, [pageNumber, quotationData, pageSize]);

  const paginationData = useMemo(() => ({
    totalRecords: quotationData?.length ?? 0,
    payload: currentTableData ?? [],
  }), [quotationData, currentTableData]);

  const handleFilterFieldChange = (id, field) => {
    setFilterRows((prev) =>
      prev.map((row) =>
        row.id === id ? { ...row, field, value: null, fromDate: "", toDate: "" } : row
      )
    );
  };

  const handleFilterValueChange = (id, selectedOption) => {
    setFilterRows((prev) =>
      prev.map((row) => (row.id === id ? { ...row, value: selectedOption } : row))
    );
  };

  const handleFilterDateChange = (id, key, value) => {
    setFilterRows((prev) =>
      prev.map((row) => (row.id === id ? { ...row, [key]: value } : row))
    );
  };

  const addFilterRow = () => {
    const usedFields = filterRows.map((row) => row.field);
    const nextField = QUOTATION_GENERAL_FILTER_FIELDS
      .map((field) => field.value)
      .find((field) => !usedFields.includes(field));
    if (!nextField) return;
    setFilterRows((prev) => [...prev, createFilterRow(nextField)]);
  };

  const removeFilterRow = (id) => {
    setFilterRows((prev) => {
      const nextRows = prev.filter((row) => row.id !== id);
      return nextRows.length > 0 ? nextRows : [createFilterRow()];
    });
  };

  const handleEdit = (item, status) => {
    if (item)
      navigate("/job-in-hand", {
        state: {
          row: item, id: item?.id,
          quotegeneral: location?.state,
          quoteType: item?.quoteType, status: status,
        },
      });
  };

  const handleView = (item) => {
    if (!item) return;
    navigate("/view-quotation", {
      state: {
        item,
        quotegeneral: location?.state,
        currencyList,
      },
    });
  };

  const navigateToJobInHand = (type) => {
    navigate("/job-in-hand", {
      state: {
        quoteType: type,
        quotegeneral: location?.state
      },
    });
  };

  const handleForecast = (item) => {
    if (item)
      navigate("/forecast", {
        state: {
          row: item, id: item?.id,
          projectCode: projectCode,
          quotegeneral: location?.state,
          currencyList: currencyList
        },
      });
  };

  const handleActivity = (item) => {
    if (menuRights?.canViewActivities !== true || !item?.id) return;
    navigate(`/quotation-activities/${encodeURIComponent(item.id)}`, {
      state: {
        quoteReference: item?.quoteReference,
        backTarget: {
          pathname: "/quotation-general",
          state: location?.state,
        },
      },
    });
  };

  //successShow
  const SuccessDoneClick = () => {
    setSuccessShow(false);
    if (
      CheckNull(createMsg?.message) == "Quotation converted to JIH successfully"
    ) {
      handleEdit(createMsg?.successData);
    } else if (
      CheckNull(createMsg?.message) == "Quotation copied successfully"
    ) {
      handleEdit(createMsg?.successData, "copy");
    }
    GetOne("quotationproject", { id: location?.state.id }, setQuotation);
  };

  const handleDelete = (item) => {
    setDeleteShow({
      show: true,
      item: item,
      title: "You want delete this Quotation?",
      textCode: "QuoteRef",
      text: item?.quoteReference,
      loading: false,
    });
  };

  const handleCancelDelete = () => {
    setDeleteShow({
      show: false,
      item: "",
      title: "",
      textCode: "",
      text: "",
      loading: false,
    });
  };

  const handleConfirmDelete = (item) => {
    setDeleteShow({
      ...deleteShow,
      loading: true,
    });
    DeleteEntry(
      "quotation",
      item,
      setCreateMsg,
      "Quotation deleted successfully",
      "Failed to delete quotation"
    );
  };

  const ClearFilter = () => {
    setFilterRows([createFilterRow()]);
    setClrFilter(true);
    setHasActiveFilters(false);
  };

  const RefreshList = () => {
    ClearFilter();
  };
  useEffect(() => {
    if (clrFilter === true) {
      ApplyFilter();
    }
  }, [clrFilter, filterRows]);

  const ApplyFilter = () => {
    const hasFilters = filterRows.some((row) => {
      if (row.field === "quoteDate") return row.fromDate || row.toDate;
      return row.value?.value !== undefined && row.value?.value !== null;
    });

    let filterResult = [...displayData];
    filterRows.forEach((row) => {
      if (row.field === "customer" && row.value?.value !== undefined && row.value?.value !== null) {
        filterResult = filterResult.filter((item) =>
          [row.value.value, String(row.value.value), Number(row.value.value)].includes(item.customerId)
        );
      }

      if (row.field === "salesEngineer" && row.value?.value !== undefined && row.value?.value !== null) {
        filterResult = filterResult.filter((item) =>
          [row.value.value, String(row.value.value)].includes(item.salesEngineerId)
        );
      }

      if (row.field === "quoteDate" && (row.fromDate || row.toDate)) {
        filterResult = filterResult.filter((item) => {
          const quoteDate = toDateOnly(item?.createdAt);
          if (!quoteDate) return false;
          if (row.fromDate && quoteDate < row.fromDate) return false;
          if (row.toDate && quoteDate > row.toDate) return false;
          return true;
        });
      }
    });

    filterResult = DataSearch(filterResult, search);
    setQuotationData(filterResult);
    setPageNumber(1);
    setClrFilter(false);
    setHasActiveFilters(hasFilters);
  };
  const ApplySearch = () => {

    setFilterDataList(prev => ({
      ...prev,
      SearchTerm: search
    }));
    setPageNumber(1);
    setShowSearchHistory(false);
    setRefreshSearch(false);
  };

  useEffect(() => {
    if (quotations?.payload) {
      setSearchHistory(quotations.payload);

      if (!filterDataList?.SearchTerm || !showSearchHistory) {
        setQuotationData(quotations.payload);
      }
    } else {
      setSearchHistory([]);

      if (!filterDataList?.SearchTerm || !showSearchHistory) {
        setQuotationData([]);
      }
    }
  }, [quotations]);

  useEffect(() => {
    if (refreshSearch === true || search == "") ApplySearch();
  }, [search]);

  const removeSearch = () => {

    setSearch("");

    setFilterDataList(prev => ({
      ...prev,
      SearchTerm: ""
    }));

    setShowSearchHistory(false);

    setRefreshSearch(true);
  };

  const handleStatusOpen = (item, selectedStatus = null) => {
    setOpenStatus({
      open: true,
      item: item,
      selectedStatus,
    });
  };

  const handleStatusClose = () => {
    setOpenStatus({
      open: false,
      item: "",
      selectedStatus: null,
    });
  };

  const handleQuotationStatusUpdate = (newStatus) => {
    UpdateQuotationStatus(
      "quotationStatusUpdate",
      newStatus,
      setCreateMsg,
      "Quotation status updated successfully",
      "Failed to update quotation Status"
    );
  };

  const ErrorDoneClick = () => {
    setErrorShow({
      show: false,
      errorMessage: "",
    });
    setCreateMsg(null);
  };

  useEffect(() => {
    if (
      CheckNull(createMsg?.message) == "Quotation status updated successfully"
    ) {
      handleStatusClose();
      setSuccessShow(true);
    } else if (
      CheckNull(createMsg?.message) == "Quotation deleted successfully"
    ) {
      setDeleteShow({
        show: false,
        item: "",
        title: "",
        textCode: "",
        text: "",
        loading: false,
      });
      setSuccessShow(true);
    } else if (
      CheckNull(createMsg?.message) == "Quotation copied successfully" ||
      CheckNull(createMsg?.message) == "Quotation converted to JIH successfully"
    ) {
      setCopyQuoteConfirm({
        show: false,
        item: "",
        title: "",
        textCode: "",
        text: "",
        loading: false,
        status: "",
      });
      setSuccessShow(true);
    } else if (createMsg?.message?.statusCode == 500) {
      setErrorShow({ show: true, errorMessage: createMsg.message });
      setDeleteShow({
        show: false,
        item: "",
        title: "",
        textCode: "",
        text: "",
        loading: false,
      });
      handleStatusClose();
    }
  }, [createMsg]);

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      ApplySearch()
      setShowSearchHistory(false);

    }
  };

  const HandleCopyQuote = (item) => {
    setCopyQuoteConfirm({
      show: true,
      item: item,
      title: "You want to copy this Quotation?",
      textCode: "QuoteRef",
      text: item?.quoteReference,
      loading: false,
      status: "copyquote",
    });
  };

  const HandleCancelProcess = () => {
    setCopyQuoteConfirm({
      show: false,
      item: "",
      title: "",
      textCode: "",
      text: "",
      loading: false,
      status: "",
    });
  };

  const HandleConfirmProcess = (item) => {
    setCopyQuoteConfirm({
      ...copyQuoteConfirm,
      loading: true,
    });

    if (copyQuoteConfirm?.status === "copyquote") {
      const copyQuote = {
        quoteReference: item?.quoteReference,
        quoteType: item?.quoteType,
        createdBy: item?.createdBy,
      };
      CreateEntry(
        "quotationcopy",
        copyQuote,
        setCreateMsg,
        "Quotation copied successfully",
        "Failed to copy quotation"
      );
    } else if (copyQuoteConfirm?.status === "convertJIH") {
      const convertQuote = {
        quoteReference: item?.quoteReference,
        createdBy: item?.createdBy,
      };
      CreateEntry(
        "quoteconvertJIH",
        convertQuote,
        setCreateMsg,
        "Quotation converted to JIH successfully",
        "Failed to covert quotation"
      );
    }
  };

  const HandleConvertJIH = (item) => {
    setCopyQuoteConfirm({
      show: true,
      item: item,
      title: "You want to convert this quote to JIH?",
      textCode: "QuoteRef",
      text: item?.quoteReference,
      loading: false,
      status: "convertJIH",
    });
  };

  return (
    <div className="container-fluid p-0" id="quotationGeneralListSec">
      <div className="row pt-1">
        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0">
          <div className="card">
            <div className="card-body">
              <div className="row search-area-row">
                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-12 col-xs-12 my-auto">
                  <div className="quote-register-count" aria-live="polite">
                    <span>{quotationData?.length}</span> Results Found
                  </div>
                </div>
                <div className="col-xxl-9 col-xl-9 col-lg-9 col-md-8 col-sm-12 col-xs-12 my-auto">
                  <div className="quote-command-bar" ref={commandBarRef}>
                      <div className="quote-search-suite">
                        <div className="input-group text-align quote-search-control">
                        <input
                          id="quotation-general-search"
                          name="quotationGeneralSearch"
                          type="text"
                          className="form-control"
                          placeholder="Search"
                          value={search}
                          onChange={(e) => {
                            const value = e.target.value;
                            setSearch(value);
                            setShowSearchHistory(true);
                            setFilterDataList(prev => ({
                              ...prev,
                              SearchTerm: value
                            }));
                          }}
                          onKeyDown={handleKeyPress}
                        />
                        {search && (
                          <button className="btn search-clear-btn" type="button" onClick={removeSearch} title="Clear search">
                            <i className="fas fa-times"></i>
                          </button>
                        )}
                        <button className="btn search-submit-btn" type="button" onClick={ApplySearch} title="Search">
                          <i className="fa fa-search"></i>
                        </button>
                      </div>
                      <div className="dropdown filter-dropdown quote-filter-control">
                        <button
                          className={`btn filter-btn ${hasActiveFilters ? "filter-active" : ""}`}
                          type="button"
                          id="filterDropdown"
                          aria-haspopup="true"
                          aria-expanded={isFilterOpen}
                          title="Advanced filters"
                          onClick={() => setIsFilterOpen((currentValue) => !currentValue)}
                        >
                          <img src={filterrSvg} alt="Filter" />
                        </button>
                        {isFilterOpen && (
                          <QuotationFilterDropdown
                            ApplyFilter={ApplyFilter}
                            ClearFilter={ClearFilter}
                            addFilterRow={addFilterRow}
                            customerData={customerData}
                            dataSources={{ salesEngineer: salesEngineerData }}
                            filterFields={QUOTATION_GENERAL_FILTER_FIELDS}
                            filterRows={filterRows}
                            handleFilterDateChange={handleFilterDateChange}
                            handleFilterFieldChange={handleFilterFieldChange}
                            handleFilterValueChange={handleFilterValueChange}
                            onCloseFilter={() => setIsFilterOpen(false)}
                            positioningTargetRef={commandBarRef}
                            removeFilterRow={removeFilterRow}
                            salesEngineerData={salesEngineerData}
                          />
                        )}
                      </div>
                      {showSearchHistory && searchHistory?.length > 0 && (
                        <div className="search-dropdown">
                          {searchHistory.map((item, index) => (
                            <div className="search-item" key={index} onClick={() => handleEdit(item)}>
                              <div className="search-title">
                                {item.quoteReference}
                              </div>
                              <div className="search-details">
                                Customer: {item.customerName}
                                {" | "}
                                Sales Engineer: {item.salesEngineerName || item.salesEngineer}
                                {" | "}
                                Quote Value: {item.grandTotal}
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>

                    <button className="btn refresh-btn" type="button" onClick={(e) => RefreshList()} title="Refresh">
                      <i className="fas fa-redo"></i>
                    </button>

                    {menuRights?.canAdd === true && (
                      <div className="dropdown">
                        <button
                          className="btn add-new-btn"
                          type="button"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          Add New <i className="fas fa-chevron-down ml-2"></i>
                        </button>
                        <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                          <ul>
                            <li onClick={() => navigateToJobInHand(1)}>
                              <span>
                                <img src={jobInHand}></img>
                                Job In Hand
                              </span>
                            </li>
                            <li onClick={() => navigateToJobInHand(2)}>
                              <span>
                                <img src={tender}></img> Tender
                              </span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {/* <!-- search-area-sec ends --> */}
            </div>
          </div>
        </div>
      </div>
      {/* <!-- search-area-sec starts --> */}
      <div className="row quotation-list-row">
        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
          {!(loading || loadings) && currentTableData?.length > 0 && (
            <div className="quote-general-stats-strip" aria-label="Quotation summary">
              <div className="quote-general-stat">
                <span>Total Quotes</span>
                <strong>{quoteStatistics?.totalQuotes || 0}</strong>
              </div>
              <div className="quote-general-stat">
                <span>Active Quotes</span>
                <strong>{quoteStatistics?.activeQuotes || 0}</strong>
              </div>
              <div className="quote-general-stat">
                <span>Quoted</span>
                <strong>{FormatValueDecimal(quoteStatistics?.quoted || 0)}</strong>
              </div>
              <div className="quote-general-stat">
                <span>Active Value</span>
                <strong>{FormatValueDecimal(quoteStatistics?.active || 0)}</strong>
              </div>
              <div className="quote-general-stat">
                <span>Lost</span>
                <strong>{FormatValueDecimal(quoteStatistics?.lost || 0)}</strong>
              </div>
              <div className="quote-general-stat">
                <span>Orders</span>
                <strong>{quoteStatistics?.order || 0}</strong>
              </div>
            </div>
          )}

          <QuotationGeneralViewGrid
            handleForecast={handleForecast}
            currentTableData={currentTableData}
            handleEdit={handleEdit}
            handleView={handleView}
            handleDelete={handleDelete}
            handleStatusOpen={handleStatusOpen}
            HandleCopyQuote={HandleCopyQuote}
            HandleConvertJIH={HandleConvertJIH}
            handleActivity={handleActivity}
            menuRights={menuRights}
            currencyList={currencyList}
            quotationStatus={quotationStatus}
            loading={loading || loadings}
            handleQuotationStatusUpdate={handleQuotationStatusUpdate}
            isProjectScoped
          />

          {(paginationData?.totalRecords ?? 0) > 0 && (
            <PaginationComponent
              moduleName="Quotation"
              count={pageSize}
              setCount={setPageSize}
              pageSize={pageSize}
              currentPage={pageNumber}
              filteredResults={paginationData}
              setCurrentPage={setPageNumber}
            />
          )}
        </div>
      </div>


      <DeleteModal
        deleteShow={deleteShow}
        handleCancelDelete={handleCancelDelete}
        handleConfirmDelete={handleConfirmDelete}
      />
      <ErrorMessage
        Show={errorShow?.show}
        errorMessage={errorShow?.errorMessage}
        ErrorDoneClick={ErrorDoneClick}
      />
      <SaveSuccessModel
        show={successShow}
        createMsg={createMsg}
        setShow={setSuccessShow}
        SuccessDoneClick={SuccessDoneClick}
      />
      <UpdateStatus
        openStatus={openStatus}
        handleStatusClose={handleStatusClose}
        quotationStatus={quotationStatus}
        handleQuotationStatusUpdate={handleQuotationStatusUpdate}
      />
      <ConfirmModal
        confirmShow={copyQuoteConfirm}
        HandleConfirmCancel={HandleCancelProcess}
        HandleConfirmOk={HandleConfirmProcess}
      />
    </div>
  );
};

export default QuotationGeneral;
